module.exports = __webpack_public_path__ + "img/quest_background_image.cc926690.png";